/* eslint-disable no-console */
import { useLocation } from "react-router-dom";
import {useProjects} from "../Behaviors/projects";
import { ProjectType } from "../api";

interface Props {
    projectId?: string /* The '?' makes projectId optional */
}

export const ProductSummarySlim = ({ projectId }: Props) => {
    const { project } = useProjects(projectId!);
    const projectType = project?.projectType;
    const reportPage = useLocation().pathname.includes(`${projectId}`);

    console.log(`ProductInfoSlim projectId=${projectId} projectType=${projectType}`);

    if (projectType !== ProjectType.Release && projectType !== ProjectType.Resource) {
        return null;
    }

    if (projectType === ProjectType.Release) {
        const releaseInfo = project?.releaseInfo!;
        return (
            <div className={reportPage ? "bg-light discrepency-report" : "bg-light my-container-vscroll row"}>
                <div className={reportPage ? "discrepency-report" : "col"}>
                    <dl className="row doubleSpaced">
                        <dt className="col-md-4">UPC</dt>
                        <dd className="col-md-8">{releaseInfo.upc}</dd>

                        <dt className="col-md-4">Artist</dt>
                        <dd className="col-md-8 truncate">{releaseInfo.artists}</dd>

                        <dt className="col-md-4">Title</dt>
                        <dd className="col-md-8 text-break">{releaseInfo.title}</dd>

                        <dt className="col-md-4">Version</dt>
                        <dd className="col-md-8 text-truncate"> {releaseInfo.version === "" ? "[n/a] " : releaseInfo.version}</dd>

                        <dt className="col-md-4">Status</dt>
                        <dd className="col-md-8 text-truncate"> {releaseInfo.status}</dd>

                        <dt className="col-md-4">Configuration</dt>
                        <dd className="col-md-8 text-truncate">{releaseInfo.configuration}</dd>

                        <dt className="col-md-4"> Parental Advisory</dt>
                        <dd className="col-md-8">{releaseInfo.parentalAdvisory} </dd>

                        <dt className="col-md-4">Resolution Type</dt>
                        <dd className="col-md-8">{releaseInfo.resolutionType === "" ? "[n/a]" : releaseInfo.resolutionType}</dd>

                        <dt className="col-md-4">Label</dt>
                        <dd className="col-md-8">{releaseInfo.labelOwner}</dd>

                        <dt className="col-md-4">Country</dt>
                        <dd className="col-md-8">{releaseInfo.countryOwner}</dd>

                        <dt className="col-md-4">AV Embargo</dt>
                        <dd className="col-md-8">{
                            releaseInfo.embargoed ?
                                releaseInfo.embargoLiftDate ? `Until ${releaseInfo.embargoLiftDate}` : "Embargoed"
                                : "None"
                        }
                        </dd>
                    </dl>
                </div>
            </div>
        );
    } else if (projectType === ProjectType.Resource) {
        const resourceInfo = project?.resourceInfo!;
        return (
            <div className={reportPage ? "bg-light" : "bg-light row"}>
                <div className={reportPage ? "" : "col"}>
                    <dl className="row doubleSpaced">
                        <dt className="col-md-4"> ISRC</dt>
                        <dd className="col-md-8">{resourceInfo.isrc}</dd>

                        <dt className="col-md-4">Artist</dt>
                        <dd className="col-md-8 truncate">{resourceInfo.artists}</dd>

                        <dt className="col-md-4">Title</dt>
                        <dd className="col-md-8 text-break"> {resourceInfo.title}</dd>

                        <dt className="col-md-4">Version</dt>
                        <dd className="col-md-8 text-truncate"> {!resourceInfo.version ? "[n/a] " : resourceInfo.version}</dd>

                        <dt className="col-md-4">Status</dt>
                        <dd className="col-md-8 text-truncate"> {resourceInfo.approvalStatus} / {resourceInfo.deliveryStatus}</dd>

                        <dt className="col-md-4">Resource Type</dt>
                        <dd className="col-md-8">{resourceInfo.resourceType}</dd>

                        <dt className="col-md-4">Parental Advisory</dt>
                        <dd className="col-md-8">{resourceInfo.parentalAdvisory}</dd>

                        <dt className="col-md-4">Channel Config</dt>
                        <dd className="col-md-8">{resourceInfo.channelConfig}</dd>

                        <dt className="col-md-4">Label</dt>
                        <dd className="col-md-8">{resourceInfo.labelOwner}</dd>

                        <dt className="col-md-4">Country</dt>
                        <dd className="col-md-8">{resourceInfo.countryOwner}</dd>
                    </dl>
                </div>
            </div>
        );
    } else {
        return null;
    }
};
